/******************************************************************************
 * This file was generated by langium-cli 4.2.0.
 * DO NOT EDIT MANUALLY!
 ******************************************************************************/

/* eslint-disable */
import * as langium from 'langium';

/** Contains the reachable terminals & keywords and all available types of the 'ArchitectureGrammar' language. */
export namespace ArchitectureGrammar {

    export const Terminals = {
        ARROW_DIRECTION: /L|R|T|B/,
        ARROW_GROUP: /\{group\}/,
        ARROW_INTO: /<|>/,
        ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
        ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
        TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
        STRING: /"([^"\\]|\\.)*"|'([^'\\]|\\.)*'/,
        ID: /[\w]([-\w]*\w)?/,
        NEWLINE: /\r?\n/,
        WHITESPACE: /[\t ]+/,
        YAML: /---[\t ]*\r?\n(?:[\S\s]*?\r?\n)?---(?:\r?\n|(?!\S))/,
        DIRECTIVE: /[\t ]*%%{[\S\s]*?}%%(?:\r?\n|(?!\S))/,
        SINGLE_LINE_COMMENT: /[\t ]*%%[^\n\r]*/,
        ARCH_ICON: /\([\w-:]+\)/,
        ARCH_TITLE: /\[(?:"([^"\\]|\\.)*"|'([^'\\]|\\.)*'|[\w ]+)\]/,
    };

    export type TerminalNames = keyof typeof Terminals;

    export type KeywordNames =
        | "-"
        | "--"
        | ":"
        | "architecture-beta"
        | "group"
        | "in"
        | "junction"
        | "service";

    export type TokenNames = TerminalNames | KeywordNames;

    export type AstType = {
        Architecture: Architecture
        Edge: Edge
        Group: Group
        Junction: Junction
        Service: Service
    }

}

/** Contains the reachable terminals & keywords and all available types of the 'GitGraphGrammar' language. */
export namespace GitGraphGrammar {

    export const Terminals = {
        ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
        ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
        TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
        INT: /0|[1-9][0-9]*(?!\.)/,
        STRING: /"([^"\\]|\\.)*"|'([^'\\]|\\.)*'/,
        NEWLINE: /\r?\n/,
        WHITESPACE: /[\t ]+/,
        YAML: /---[\t ]*\r?\n(?:[\S\s]*?\r?\n)?---(?:\r?\n|(?!\S))/,
        DIRECTIVE: /[\t ]*%%{[\S\s]*?}%%(?:\r?\n|(?!\S))/,
        SINGLE_LINE_COMMENT: /[\t ]*%%[^\n\r]*/,
        REFERENCE: /\w([-\./\w]*[-\w])?/,
    };

    export type TerminalNames = keyof typeof Terminals;

    export type KeywordNames =
        | ":"
        | "BT"
        | "HIGHLIGHT"
        | "LR"
        | "NORMAL"
        | "REVERSE"
        | "TB"
        | "branch"
        | "checkout"
        | "cherry-pick"
        | "commit"
        | "gitGraph"
        | "gitGraph:"
        | "id:"
        | "merge"
        | "msg:"
        | "order:"
        | "parent:"
        | "switch"
        | "tag:"
        | "type:";

    export type TokenNames = TerminalNames | KeywordNames;

    export type AstType = {
        Branch: Branch
        Checkout: Checkout
        CherryPicking: CherryPicking
        Commit: Commit
        Direction: Direction
        GitGraph: GitGraph
        Merge: Merge
        Statement: Statement
    }

}

/** Contains the reachable terminals & keywords and all available types of the 'InfoGrammar' language. */
export namespace InfoGrammar {

    export const Terminals = {
        ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
        ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
        TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
        NEWLINE: /\r?\n/,
        WHITESPACE: /[\t ]+/,
        YAML: /---[\t ]*\r?\n(?:[\S\s]*?\r?\n)?---(?:\r?\n|(?!\S))/,
        DIRECTIVE: /[\t ]*%%{[\S\s]*?}%%(?:\r?\n|(?!\S))/,
        SINGLE_LINE_COMMENT: /[\t ]*%%[^\n\r]*/,
    };

    export type TerminalNames = keyof typeof Terminals;

    export type KeywordNames =
        | "info"
        | "showInfo";

    export type TokenNames = TerminalNames | KeywordNames;

    export type AstType = {
        Info: Info
    }

}

/** Contains the reachable terminals & keywords and all available types of the 'PacketGrammar' language. */
export namespace PacketGrammar {

    export const Terminals = {
        ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
        ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
        TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
        INT: /0|[1-9][0-9]*(?!\.)/,
        STRING: /"([^"\\]|\\.)*"|'([^'\\]|\\.)*'/,
        NEWLINE: /\r?\n/,
        WHITESPACE: /[\t ]+/,
        YAML: /---[\t ]*\r?\n(?:[\S\s]*?\r?\n)?---(?:\r?\n|(?!\S))/,
        DIRECTIVE: /[\t ]*%%{[\S\s]*?}%%(?:\r?\n|(?!\S))/,
        SINGLE_LINE_COMMENT: /[\t ]*%%[^\n\r]*/,
    };

    export type TerminalNames = keyof typeof Terminals;

    export type KeywordNames =
        | "+"
        | "-"
        | ":"
        | "packet"
        | "packet-beta";

    export type TokenNames = TerminalNames | KeywordNames;

    export type AstType = {
        Packet: Packet
        PacketBlock: PacketBlock
    }

}

/** Contains the reachable terminals & keywords and all available types of the 'PieGrammar' language. */
export namespace PieGrammar {

    export const Terminals = {
        NUMBER_PIE: /(?:-?[0-9]+\.[0-9]+(?!\.))|(?:-?(0|[1-9][0-9]*)(?!\.))/,
        ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
        ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
        TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
        STRING: /"([^"\\]|\\.)*"|'([^'\\]|\\.)*'/,
        NEWLINE: /\r?\n/,
        WHITESPACE: /[\t ]+/,
        YAML: /---[\t ]*\r?\n(?:[\S\s]*?\r?\n)?---(?:\r?\n|(?!\S))/,
        DIRECTIVE: /[\t ]*%%{[\S\s]*?}%%(?:\r?\n|(?!\S))/,
        SINGLE_LINE_COMMENT: /[\t ]*%%[^\n\r]*/,
    };

    export type TerminalNames = keyof typeof Terminals;

    export type KeywordNames =
        | ":"
        | "pie"
        | "showData";

    export type TokenNames = TerminalNames | KeywordNames;

    export type AstType = {
        Pie: Pie
        PieSection: PieSection
    }

}

/** Contains the reachable terminals & keywords and all available types of the 'RadarGrammar' language. */
export namespace RadarGrammar {

    export const Terminals = {
        GRATICULE: /circle|polygon/,
        BOOLEAN: /true|false/,
        ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
        ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
        TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
        NUMBER: /(?:[0-9]+\.[0-9]+(?!\.))|(?:0|[1-9][0-9]*(?!\.))/,
        STRING: /"([^"\\]|\\.)*"|'([^'\\]|\\.)*'/,
        ID: /[\w]([-\w]*\w)?/,
        NEWLINE: /\r?\n/,
        WHITESPACE: /[\t ]+/,
        YAML: /---[\t ]*\r?\n(?:[\S\s]*?\r?\n)?---(?:\r?\n|(?!\S))/,
        DIRECTIVE: /[\t ]*%%{[\S\s]*?}%%(?:\r?\n|(?!\S))/,
        SINGLE_LINE_COMMENT: /[\t ]*%%[^\n\r]*/,
    };

    export type TerminalNames = keyof typeof Terminals;

    export type KeywordNames =
        | ","
        | ":"
        | "["
        | "]"
        | "axis"
        | "curve"
        | "graticule"
        | "max"
        | "min"
        | "radar-beta"
        | "radar-beta:"
        | "showLegend"
        | "ticks"
        | "{"
        | "}";

    export type TokenNames = TerminalNames | KeywordNames;

    export type AstType = {
        Axis: Axis
        Curve: Curve
        Entry: Entry
        Option: Option
        Radar: Radar
    }

}

/** Contains the reachable terminals & keywords and all available types of the 'TreemapGrammar' language. */
export namespace TreemapGrammar {

    export const Terminals = {
        ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
        ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
        TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
        TREEMAP_KEYWORD: /treemap-beta|treemap/,
        CLASS_DEF: /classDef\s+([a-zA-Z_][a-zA-Z0-9_]+)(?:\s+([^;\r\n]*))?(?:;)?/,
        STYLE_SEPARATOR: /:::/,
        SEPARATOR: /:/,
        COMMA: /,/,
        INDENTATION: /[ \t]{1,}/,
        WS: /[ \t]+/,
        ML_COMMENT: /\%\%[^\n]*/,
        NL: /\r?\n/,
        ID2: /[a-zA-Z_][a-zA-Z0-9_]*/,
        NUMBER2: /[0-9_\.\,]+/,
        STRING2: /"[^"]*"|'[^']*'/,
    };

    export type TerminalNames = keyof typeof Terminals;

    export type KeywordNames = never;

    export type TokenNames = TerminalNames | KeywordNames;

    export type AstType = {
        ClassDefStatement: ClassDefStatement
        Item: Item
        Leaf: Leaf
        Section: Section
        Treemap: Treemap
        TreemapRow: TreemapRow
    }

}

/** Contains the reachable terminals & keywords and all available types of the 'TreeViewGrammar' language. */
export namespace TreeViewGrammar {

    export const Terminals = {
        ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
        ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
        TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
        INDENTATION: /[ \t]{1,}/,
        WS: /[ \t]+/,
        ML_COMMENT: /\%\%[^\n]*/,
        NL: /\r?\n/,
        STRING2: /"[^"]*"|'[^']*'/,
    };

    export type TerminalNames = keyof typeof Terminals;

    export type KeywordNames =
        | "treeView-beta";

    export type TokenNames = TerminalNames | KeywordNames;

    export type AstType = {
        TreeNode: TreeNode
        TreeView: TreeView
    }

}

/** Contains the reachable terminals & keywords and all available types of the 'WardleyGrammar' language. */
export namespace WardleyGrammar {

    export const Terminals = {
        WARDLEY_NUMBER: /[0-9]+\.[0-9]+/,
        ARROW: /->/,
        LINK_PORT: /\+<>|\+>|\+</,
        LINK_ARROW: /-->|-\.->|>|\+'[^']*'<>|\+'[^']*'<|\+'[^']*'>/,
        LINK_LABEL: /;[^\n\r]+/,
        STRATEGY: /build|buy|outsource|market/,
        KW_WARDLEY: /wardley-beta/,
        KW_SIZE: /size/,
        KW_EVOLUTION: /evolution/,
        KW_ANCHOR: /anchor/,
        KW_COMPONENT: /component/,
        KW_LABEL: /label/,
        KW_INERTIA: /inertia/,
        KW_EVOLVE: /evolve/,
        KW_PIPELINE: /pipeline/,
        KW_NOTE: /note/,
        KW_ANNOTATIONS: /annotations/,
        KW_ANNOTATION: /annotation/,
        KW_ACCELERATOR: /accelerator/,
        KW_DEACCELERATOR: /deaccelerator/,
        NAME_WITH_SPACES: /(?!title\s|accTitle|accDescr)[A-Za-z][A-Za-z0-9_()&]*(?:[ \t]+[A-Za-z(][A-Za-z0-9_()&]*)*/,
        WS: /[ \t]+/,
        ACC_DESCR: /[\t ]*accDescr(?:[\t ]*:([^\n\r]*?(?=%%)|[^\n\r]*)|\s*{([^}]*)})/,
        ACC_TITLE: /[\t ]*accTitle[\t ]*:(?:[^\n\r]*?(?=%%)|[^\n\r]*)/,
        TITLE: /[\t ]*title(?:[\t ][^\n\r]*?(?=%%)|[\t ][^\n\r]*|)/,
        INT: /0|[1-9][0-9]*(?!\.)/,
        STRING: /"([^"\\]|\\.)*"|'([^'\\]|\\.)*'/,
        ID: /[\w]([-\w]*\w)?/,
        NEWLINE: /\r?\n/,
        WHITESPACE: /[\t ]+/,
        YAML: /---[\t ]*\r?\n(?:[\S\s]*?\r?\n)?---(?:\r?\n|(?!\S))/,
        DIRECTIVE: /[\t ]*%%{[\S\s]*?}%%(?:\r?\n|(?!\S))/,
        SINGLE_LINE_COMMENT: /[\t ]*%%[^\n\r]*/,
    };

    export type TerminalNames = keyof typeof Terminals;

    export type KeywordNames =
        | "("
        | ")"
        | ","
        | "-"
        | "/"
        | "@"
        | "["
        | "]"
        | "{"
        | "}";

    export type TokenNames = TerminalNames | KeywordNames;

    export type AstType = {
        Accelerator: Accelerator
        Anchor: Anchor
        Annotation: Annotation
        Annotations: Annotations
        Component: Component
        Deaccelerator: Deaccelerator
        Decorator: Decorator
        Evolution: Evolution
        EvolutionStage: EvolutionStage
        Evolve: Evolve
        Label: Label
        Link: Link
        Note: Note
        Pipeline: Pipeline
        PipelineComponent: PipelineComponent
        Size: Size
        Wardley: Wardley
    }

}


// the terminals, keywords and types of the whole 'Mermaid' project

export const MermaidTerminals = {
    ...ArchitectureGrammar.Terminals,
    ...GitGraphGrammar.Terminals,
    ...InfoGrammar.Terminals,
    ...PacketGrammar.Terminals,
    ...PieGrammar.Terminals,
    ...RadarGrammar.Terminals,
    ...TreeViewGrammar.Terminals,
    ...TreemapGrammar.Terminals,
    ...WardleyGrammar.Terminals,
};

export type MermaidTerminalNames = keyof typeof MermaidTerminals;

export type MermaidKeywordNames = ArchitectureGrammar.KeywordNames | GitGraphGrammar.KeywordNames | InfoGrammar.KeywordNames | PacketGrammar.KeywordNames | PieGrammar.KeywordNames | RadarGrammar.KeywordNames | TreeViewGrammar.KeywordNames | TreemapGrammar.KeywordNames | WardleyGrammar.KeywordNames;

export type MermaidTokenNames = MermaidTerminalNames | MermaidKeywordNames;

export type MermaidAstType = ArchitectureGrammar.AstType & GitGraphGrammar.AstType & InfoGrammar.AstType & PacketGrammar.AstType & PieGrammar.AstType & RadarGrammar.AstType & TreeViewGrammar.AstType & TreemapGrammar.AstType & WardleyGrammar.AstType


// all type definitions of the the whole 'Mermaid' project

export interface Accelerator extends langium.AstNode {
    readonly $container: Wardley;
    readonly $type: 'Accelerator' | 'EOL';
    name: string;
    x: number;
    y: number;
}

export const Accelerator = {
    $type: 'Accelerator',
    name: 'name',
    x: 'x',
    y: 'y'
} as const;

export function isAccelerator(item: unknown): item is Accelerator {
    return reflection.isInstance(item, Accelerator.$type);
}

export interface Anchor extends langium.AstNode {
    readonly $container: Wardley;
    readonly $type: 'Anchor' | 'EOL';
    evolution: number;
    name: string;
    visibility: number;
}

export const Anchor = {
    $type: 'Anchor',
    evolution: 'evolution',
    name: 'name',
    visibility: 'visibility'
} as const;

export function isAnchor(item: unknown): item is Anchor {
    return reflection.isInstance(item, Anchor.$type);
}

export interface Annotation extends langium.AstNode {
    readonly $container: Wardley;
    readonly $type: 'Annotation' | 'EOL';
    number: number;
    text: string;
    x: CoordinateValue;
    y: CoordinateValue;
}

export const Annotation = {
    $type: 'Annotation',
    number: 'number',
    text: 'text',
    x: 'x',
    y: 'y'
} as const;

export function isAnnotation(item: unknown): item is Annotation {
    return reflection.isInstance(item, Annotation.$type);
}

export interface Annotations extends langium.AstNode {
    readonly $container: Wardley;
    readonly $type: 'Annotations' | 'EOL';
    x: CoordinateValue;
    y: CoordinateValue;
}

export const Annotations = {
    $type: 'Annotations',
    x: 'x',
    y: 'y'
} as const;

export function isAnnotations(item: unknown): item is Annotations {
    return reflection.isInstance(item, Annotations.$type);
}

export interface Architecture extends langium.AstNode {
    readonly $type: 'Architecture';
    accDescr?: string;
    accTitle?: string;
    edges: Array<Edge>;
    groups: Array<Group>;
    junctions: Array<Junction>;
    services: Array<Service>;
    title?: string;
}

export const Architecture = {
    $type: 'Architecture',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    edges: 'edges',
    groups: 'groups',
    junctions: 'junctions',
    services: 'services',
    title: 'title'
} as const;

export function isArchitecture(item: unknown): item is Architecture {
    return reflection.isInstance(item, Architecture.$type);
}

export interface Axis extends langium.AstNode {
    readonly $container: Radar;
    readonly $type: 'Axis';
    label?: string;
    name: string;
}

export const Axis = {
    $type: 'Axis',
    label: 'label',
    name: 'name'
} as const;

export function isAxis(item: unknown): item is Axis {
    return reflection.isInstance(item, Axis.$type);
}

export interface Branch extends langium.AstNode {
    readonly $container: GitGraph;
    readonly $type: 'Branch' | 'EOL';
    name: string;
    order: number;
}

export const Branch = {
    $type: 'Branch',
    name: 'name',
    order: 'order'
} as const;

export function isBranch(item: unknown): item is Branch {
    return reflection.isInstance(item, Branch.$type);
}

export interface Checkout extends langium.AstNode {
    readonly $container: GitGraph;
    readonly $type: 'Checkout' | 'EOL';
    branch: string;
}

export const Checkout = {
    $type: 'Checkout',
    branch: 'branch'
} as const;

export function isCheckout(item: unknown): item is Checkout {
    return reflection.isInstance(item, Checkout.$type);
}

export interface CherryPicking extends langium.AstNode {
    readonly $container: GitGraph;
    readonly $type: 'CherryPicking' | 'EOL';
    id: string;
    parent: string;
    tags: Array<string>;
}

export const CherryPicking = {
    $type: 'CherryPicking',
    id: 'id',
    parent: 'parent',
    tags: 'tags'
} as const;

export function isCherryPicking(item: unknown): item is CherryPicking {
    return reflection.isInstance(item, CherryPicking.$type);
}

export type ClassDef = string;

export function isClassDef(item: unknown): item is ClassDef {
    return (typeof item === 'string' && (/classDef\s+([a-zA-Z_][a-zA-Z0-9_]+)(?:\s+([^;\r\n]*))?(?:;)?/.test(item)));
}

export interface ClassDefStatement extends langium.AstNode {
    readonly $type: 'ClassDefStatement';
    className: string;
    styleText: string;
}

export const ClassDefStatement = {
    $type: 'ClassDefStatement',
    className: 'className',
    styleText: 'styleText'
} as const;

export function isClassDefStatement(item: unknown): item is ClassDefStatement {
    return reflection.isInstance(item, ClassDefStatement.$type);
}

export interface Commit extends langium.AstNode {
    readonly $container: GitGraph;
    readonly $type: 'Commit' | 'EOL';
    id: string;
    message: string;
    tags: Array<string>;
    type: 'HIGHLIGHT' | 'NORMAL' | 'REVERSE';
}

export const Commit = {
    $type: 'Commit',
    id: 'id',
    message: 'message',
    tags: 'tags',
    type: 'type'
} as const;

export function isCommit(item: unknown): item is Commit {
    return reflection.isInstance(item, Commit.$type);
}

export interface Component extends langium.AstNode {
    readonly $container: Wardley;
    readonly $type: 'Component' | 'EOL';
    decorator?: Decorator;
    evolution: number;
    inertia: boolean;
    label?: Label;
    name: string;
    visibility: number;
}

export const Component = {
    $type: 'Component',
    decorator: 'decorator',
    evolution: 'evolution',
    inertia: 'inertia',
    label: 'label',
    name: 'name',
    visibility: 'visibility'
} as const;

export function isComponent(item: unknown): item is Component {
    return reflection.isInstance(item, Component.$type);
}

export type CoordinateValue = number;

export function isCoordinateValue(item: unknown): item is CoordinateValue {
    return typeof item === 'number';
}

export interface Curve extends langium.AstNode {
    readonly $container: Radar;
    readonly $type: 'Curve';
    entries: Array<Entry>;
    label?: string;
    name: string;
}

export const Curve = {
    $type: 'Curve',
    entries: 'entries',
    label: 'label',
    name: 'name'
} as const;

export function isCurve(item: unknown): item is Curve {
    return reflection.isInstance(item, Curve.$type);
}

export interface Deaccelerator extends langium.AstNode {
    readonly $container: Wardley;
    readonly $type: 'Deaccelerator' | 'EOL';
    name: string;
    x: number;
    y: number;
}

export const Deaccelerator = {
    $type: 'Deaccelerator',
    name: 'name',
    x: 'x',
    y: 'y'
} as const;

export function isDeaccelerator(item: unknown): item is Deaccelerator {
    return reflection.isInstance(item, Deaccelerator.$type);
}

export interface Decorator extends langium.AstNode {
    readonly $container: Component;
    readonly $type: 'Decorator';
    strategy: string;
}

export const Decorator = {
    $type: 'Decorator',
    strategy: 'strategy'
} as const;

export function isDecorator(item: unknown): item is Decorator {
    return reflection.isInstance(item, Decorator.$type);
}

export interface Direction extends GitGraph {
    readonly $type: 'Direction';
    dir: 'BT' | 'LR' | 'TB';
}

export const Direction = {
    $type: 'Direction',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    dir: 'dir',
    statements: 'statements',
    title: 'title'
} as const;

export function isDirection(item: unknown): item is Direction {
    return reflection.isInstance(item, Direction.$type);
}

export interface Edge extends langium.AstNode {
    readonly $container: Architecture;
    readonly $type: 'EOL' | 'Edge';
    lhsDir: string;
    lhsGroup: boolean;
    lhsId: string;
    lhsInto: boolean;
    rhsDir: string;
    rhsGroup: boolean;
    rhsId: string;
    rhsInto: boolean;
    title?: string;
}

export const Edge = {
    $type: 'Edge',
    lhsDir: 'lhsDir',
    lhsGroup: 'lhsGroup',
    lhsId: 'lhsId',
    lhsInto: 'lhsInto',
    rhsDir: 'rhsDir',
    rhsGroup: 'rhsGroup',
    rhsId: 'rhsId',
    rhsInto: 'rhsInto',
    title: 'title'
} as const;

export function isEdge(item: unknown): item is Edge {
    return reflection.isInstance(item, Edge.$type);
}

export interface Entry extends langium.AstNode {
    readonly $container: Curve;
    readonly $type: 'Entry';
    axis?: langium.Reference<Axis>;
    value: number;
}

export const Entry = {
    $type: 'Entry',
    axis: 'axis',
    value: 'value'
} as const;

export function isEntry(item: unknown): item is Entry {
    return reflection.isInstance(item, Entry.$type);
}

export type EOL = string;

export function isEOL(item: unknown): item is EOL {
    return typeof item === 'string';
}

export interface Evolution extends langium.AstNode {
    readonly $container: Wardley;
    readonly $type: 'EOL' | 'Evolution';
    stages: Array<EvolutionStage>;
}

export const Evolution = {
    $type: 'Evolution',
    stages: 'stages'
} as const;

export function isEvolution(item: unknown): item is Evolution {
    return reflection.isInstance(item, Evolution.$type);
}

export interface EvolutionStage extends langium.AstNode {
    readonly $container: Evolution;
    readonly $type: 'EvolutionStage';
    boundary?: number;
    name: string;
    secondName?: string;
}

export const EvolutionStage = {
    $type: 'EvolutionStage',
    boundary: 'boundary',
    name: 'name',
    secondName: 'secondName'
} as const;

export function isEvolutionStage(item: unknown): item is EvolutionStage {
    return reflection.isInstance(item, EvolutionStage.$type);
}

export interface Evolve extends langium.AstNode {
    readonly $container: Wardley;
    readonly $type: 'EOL' | 'Evolve';
    component: string;
    target: number;
}

export const Evolve = {
    $type: 'Evolve',
    component: 'component',
    target: 'target'
} as const;

export function isEvolve(item: unknown): item is Evolve {
    return reflection.isInstance(item, Evolve.$type);
}

export interface GitGraph extends langium.AstNode {
    readonly $type: 'Direction' | 'GitGraph';
    accDescr: string;
    accTitle: string;
    statements: Array<Statement>;
    title: string;
}

export const GitGraph = {
    $type: 'GitGraph',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    statements: 'statements',
    title: 'title'
} as const;

export function isGitGraph(item: unknown): item is GitGraph {
    return reflection.isInstance(item, GitGraph.$type);
}

export interface Group extends langium.AstNode {
    readonly $container: Architecture;
    readonly $type: 'EOL' | 'Group';
    icon?: string;
    id: string;
    in: string;
    title?: string;
}

export const Group = {
    $type: 'Group',
    icon: 'icon',
    id: 'id',
    in: 'in',
    title: 'title'
} as const;

export function isGroup(item: unknown): item is Group {
    return reflection.isInstance(item, Group.$type);
}

export interface Info extends langium.AstNode {
    readonly $type: 'Info';
    accDescr?: string;
    accTitle?: string;
    title?: string;
}

export const Info = {
    $type: 'Info',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    title: 'title'
} as const;

export function isInfo(item: unknown): item is Info {
    return reflection.isInstance(item, Info.$type);
}

export interface Item extends langium.AstNode {
    readonly $type: 'Item' | 'Leaf' | 'Section';
    classSelector?: string;
    name: string;
}

export const Item = {
    $type: 'Item',
    classSelector: 'classSelector',
    name: 'name'
} as const;

export function isItem(item: unknown): item is Item {
    return reflection.isInstance(item, Item.$type);
}

export interface Junction extends langium.AstNode {
    readonly $container: Architecture;
    readonly $type: 'EOL' | 'Junction';
    id: string;
    in: string;
}

export const Junction = {
    $type: 'Junction',
    id: 'id',
    in: 'in'
} as const;

export function isJunction(item: unknown): item is Junction {
    return reflection.isInstance(item, Junction.$type);
}

export interface Label extends langium.AstNode {
    readonly $container: Component | PipelineComponent;
    readonly $type: 'Label';
    negX: boolean;
    negY: boolean;
    offsetX: number;
    offsetY: number;
}

export const Label = {
    $type: 'Label',
    negX: 'negX',
    negY: 'negY',
    offsetX: 'offsetX',
    offsetY: 'offsetY'
} as const;

export function isLabel(item: unknown): item is Label {
    return reflection.isInstance(item, Label.$type);
}

export interface Leaf extends Item {
    readonly $type: 'Leaf';
    value: number;
}

export const Leaf = {
    $type: 'Leaf',
    classSelector: 'classSelector',
    name: 'name',
    value: 'value'
} as const;

export function isLeaf(item: unknown): item is Leaf {
    return reflection.isInstance(item, Leaf.$type);
}

export interface Link extends langium.AstNode {
    readonly $container: Wardley;
    readonly $type: 'EOL' | 'Link';
    arrow?: string;
    from: string;
    fromPort?: string;
    linkLabel?: string;
    to: string;
    toPort?: string;
}

export const Link = {
    $type: 'Link',
    arrow: 'arrow',
    from: 'from',
    fromPort: 'fromPort',
    linkLabel: 'linkLabel',
    to: 'to',
    toPort: 'toPort'
} as const;

export function isLink(item: unknown): item is Link {
    return reflection.isInstance(item, Link.$type);
}

export interface Merge extends langium.AstNode {
    readonly $container: GitGraph;
    readonly $type: 'EOL' | 'Merge';
    branch: string;
    id: string;
    tags: Array<string>;
    type: 'HIGHLIGHT' | 'NORMAL' | 'REVERSE';
}

export const Merge = {
    $type: 'Merge',
    branch: 'branch',
    id: 'id',
    tags: 'tags',
    type: 'type'
} as const;

export function isMerge(item: unknown): item is Merge {
    return reflection.isInstance(item, Merge.$type);
}

export type MyNumber = number;

export function isMyNumber(item: unknown): item is MyNumber {
    return typeof item === 'number';
}

export interface Note extends langium.AstNode {
    readonly $container: Wardley;
    readonly $type: 'EOL' | 'Note';
    evolution: number;
    text: string;
    visibility: number;
}

export const Note = {
    $type: 'Note',
    evolution: 'evolution',
    text: 'text',
    visibility: 'visibility'
} as const;

export function isNote(item: unknown): item is Note {
    return reflection.isInstance(item, Note.$type);
}

export interface Option extends langium.AstNode {
    readonly $container: Radar;
    readonly $type: 'Option';
    name: 'graticule' | 'max' | 'min' | 'showLegend' | 'ticks';
    value: boolean | number | string;
}

export const Option = {
    $type: 'Option',
    name: 'name',
    value: 'value'
} as const;

export function isOption(item: unknown): item is Option {
    return reflection.isInstance(item, Option.$type);
}

export interface Packet extends langium.AstNode {
    readonly $type: 'Packet';
    accDescr?: string;
    accTitle?: string;
    blocks: Array<PacketBlock>;
    title?: string;
}

export const Packet = {
    $type: 'Packet',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    blocks: 'blocks',
    title: 'title'
} as const;

export function isPacket(item: unknown): item is Packet {
    return reflection.isInstance(item, Packet.$type);
}

export interface PacketBlock extends langium.AstNode {
    readonly $container: Packet;
    readonly $type: 'EOL' | 'PacketBlock';
    bits: number;
    end?: number;
    label: string;
    start: number;
}

export const PacketBlock = {
    $type: 'PacketBlock',
    bits: 'bits',
    end: 'end',
    label: 'label',
    start: 'start'
} as const;

export function isPacketBlock(item: unknown): item is PacketBlock {
    return reflection.isInstance(item, PacketBlock.$type);
}

export interface Pie extends langium.AstNode {
    readonly $type: 'Pie';
    accDescr?: string;
    accTitle?: string;
    sections: Array<PieSection>;
    showData: boolean;
    title?: string;
}

export const Pie = {
    $type: 'Pie',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    sections: 'sections',
    showData: 'showData',
    title: 'title'
} as const;

export function isPie(item: unknown): item is Pie {
    return reflection.isInstance(item, Pie.$type);
}

export interface PieSection extends langium.AstNode {
    readonly $container: Pie;
    readonly $type: 'EOL' | 'PieSection';
    label: string;
    value: number;
}

export const PieSection = {
    $type: 'PieSection',
    label: 'label',
    value: 'value'
} as const;

export function isPieSection(item: unknown): item is PieSection {
    return reflection.isInstance(item, PieSection.$type);
}

export interface Pipeline extends langium.AstNode {
    readonly $container: Wardley;
    readonly $type: 'EOL' | 'Pipeline';
    components: Array<PipelineComponent>;
    parent: string;
}

export const Pipeline = {
    $type: 'Pipeline',
    components: 'components',
    parent: 'parent'
} as const;

export function isPipeline(item: unknown): item is Pipeline {
    return reflection.isInstance(item, Pipeline.$type);
}

export interface PipelineComponent extends langium.AstNode {
    readonly $container: Pipeline;
    readonly $type: 'EOL' | 'PipelineComponent';
    evolution: number;
    label?: Label;
    name: string;
}

export const PipelineComponent = {
    $type: 'PipelineComponent',
    evolution: 'evolution',
    label: 'label',
    name: 'name'
} as const;

export function isPipelineComponent(item: unknown): item is PipelineComponent {
    return reflection.isInstance(item, PipelineComponent.$type);
}

export interface Radar extends langium.AstNode {
    readonly $type: 'Radar';
    accDescr?: string;
    accTitle?: string;
    axes: Array<Axis>;
    curves: Array<Curve>;
    options: Array<Option>;
    title?: string;
}

export const Radar = {
    $type: 'Radar',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    axes: 'axes',
    curves: 'curves',
    options: 'options',
    title: 'title'
} as const;

export function isRadar(item: unknown): item is Radar {
    return reflection.isInstance(item, Radar.$type);
}

export interface Section extends Item {
    readonly $type: 'Section';
}

export const Section = {
    $type: 'Section',
    classSelector: 'classSelector',
    name: 'name'
} as const;

export function isSection(item: unknown): item is Section {
    return reflection.isInstance(item, Section.$type);
}

export interface Service extends langium.AstNode {
    readonly $container: Architecture;
    readonly $type: 'EOL' | 'Service';
    icon?: string;
    iconText?: string;
    id: string;
    in: string;
    title?: string;
}

export const Service = {
    $type: 'Service',
    icon: 'icon',
    iconText: 'iconText',
    id: 'id',
    in: 'in',
    title: 'title'
} as const;

export function isService(item: unknown): item is Service {
    return reflection.isInstance(item, Service.$type);
}

export interface Size extends langium.AstNode {
    readonly $container: Wardley;
    readonly $type: 'EOL' | 'Size';
    height: number;
    width: number;
}

export const Size = {
    $type: 'Size',
    height: 'height',
    width: 'width'
} as const;

export function isSize(item: unknown): item is Size {
    return reflection.isInstance(item, Size.$type);
}

export type Statement = Branch | Checkout | CherryPicking | Commit | Merge;

export const Statement = {
    $type: 'Statement'
} as const;

export function isStatement(item: unknown): item is Statement {
    return reflection.isInstance(item, Statement.$type);
}

export interface Treemap extends langium.AstNode {
    readonly $type: 'Treemap';
    accDescr?: string;
    accTitle?: string;
    title?: string;
    TreemapRows: Array<TreemapRow>;
}

export const Treemap = {
    $type: 'Treemap',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    title: 'title',
    TreemapRows: 'TreemapRows'
} as const;

export function isTreemap(item: unknown): item is Treemap {
    return reflection.isInstance(item, Treemap.$type);
}

export interface TreemapRow extends langium.AstNode {
    readonly $container: Treemap;
    readonly $type: 'ClassDef' | 'TreemapRow';
    indent?: string;
    item: Item;
}

export const TreemapRow = {
    $type: 'TreemapRow',
    indent: 'indent',
    item: 'item'
} as const;

export function isTreemapRow(item: unknown): item is TreemapRow {
    return reflection.isInstance(item, TreemapRow.$type);
}

export interface TreeNode extends langium.AstNode {
    readonly $container: TreeView;
    readonly $type: 'TreeNode';
    indent?: string;
    name: string;
}

export const TreeNode = {
    $type: 'TreeNode',
    indent: 'indent',
    name: 'name'
} as const;

export function isTreeNode(item: unknown): item is TreeNode {
    return reflection.isInstance(item, TreeNode.$type);
}

export interface TreeView extends langium.AstNode {
    readonly $type: 'TreeView';
    accDescr?: string;
    accTitle?: string;
    nodes: Array<TreeNode>;
    title?: string;
}

export const TreeView = {
    $type: 'TreeView',
    accDescr: 'accDescr',
    accTitle: 'accTitle',
    nodes: 'nodes',
    title: 'title'
} as const;

export function isTreeView(item: unknown): item is TreeView {
    return reflection.isInstance(item, TreeView.$type);
}

export interface Wardley extends langium.AstNode {
    readonly $type: 'Wardley';
    accDescr?: string;
    accelerators: Array<Accelerator>;
    accTitle?: string;
    anchors: Array<Anchor>;
    annotation: Array<Annotation>;
    annotations: Array<Annotations>;
    components: Array<Component>;
    deaccelerators: Array<Deaccelerator>;
    evolution?: Evolution;
    evolves: Array<Evolve>;
    links: Array<Link>;
    notes: Array<Note>;
    pipelines: Array<Pipeline>;
    size?: Size;
    title?: string;
}

export const Wardley = {
    $type: 'Wardley',
    accDescr: 'accDescr',
    accelerators: 'accelerators',
    accTitle: 'accTitle',
    anchors: 'anchors',
    annotation: 'annotation',
    annotations: 'annotations',
    components: 'components',
    deaccelerators: 'deaccelerators',
    evolution: 'evolution',
    evolves: 'evolves',
    links: 'links',
    notes: 'notes',
    pipelines: 'pipelines',
    size: 'size',
    title: 'title'
} as const;

export function isWardley(item: unknown): item is Wardley {
    return reflection.isInstance(item, Wardley.$type);
}

export class MermaidAstReflection extends langium.AbstractAstReflection {
    override readonly types = {
        Accelerator: {
            name: Accelerator.$type,
            properties: {
                name: {
                    name: Accelerator.name
                },
                x: {
                    name: Accelerator.x
                },
                y: {
                    name: Accelerator.y
                }
            },
            superTypes: []
        },
        Anchor: {
            name: Anchor.$type,
            properties: {
                evolution: {
                    name: Anchor.evolution
                },
                name: {
                    name: Anchor.name
                },
                visibility: {
                    name: Anchor.visibility
                }
            },
            superTypes: []
        },
        Annotation: {
            name: Annotation.$type,
            properties: {
                number: {
                    name: Annotation.number
                },
                text: {
                    name: Annotation.text
                },
                x: {
                    name: Annotation.x
                },
                y: {
                    name: Annotation.y
                }
            },
            superTypes: []
        },
        Annotations: {
            name: Annotations.$type,
            properties: {
                x: {
                    name: Annotations.x
                },
                y: {
                    name: Annotations.y
                }
            },
            superTypes: []
        },
        Architecture: {
            name: Architecture.$type,
            properties: {
                accDescr: {
                    name: Architecture.accDescr
                },
                accTitle: {
                    name: Architecture.accTitle
                },
                edges: {
                    name: Architecture.edges,
                    defaultValue: []
                },
                groups: {
                    name: Architecture.groups,
                    defaultValue: []
                },
                junctions: {
                    name: Architecture.junctions,
                    defaultValue: []
                },
                services: {
                    name: Architecture.services,
                    defaultValue: []
                },
                title: {
                    name: Architecture.title
                }
            },
            superTypes: []
        },
        Axis: {
            name: Axis.$type,
            properties: {
                label: {
                    name: Axis.label
                },
                name: {
                    name: Axis.name
                }
            },
            superTypes: []
        },
        Branch: {
            name: Branch.$type,
            properties: {
                name: {
                    name: Branch.name
                },
                order: {
                    name: Branch.order
                }
            },
            superTypes: [Statement.$type]
        },
        Checkout: {
            name: Checkout.$type,
            properties: {
                branch: {
                    name: Checkout.branch
                }
            },
            superTypes: [Statement.$type]
        },
        CherryPicking: {
            name: CherryPicking.$type,
            properties: {
                id: {
                    name: CherryPicking.id
                },
                parent: {
                    name: CherryPicking.parent
                },
                tags: {
                    name: CherryPicking.tags,
                    defaultValue: []
                }
            },
            superTypes: [Statement.$type]
        },
        ClassDefStatement: {
            name: ClassDefStatement.$type,
            properties: {
                className: {
                    name: ClassDefStatement.className
                },
                styleText: {
                    name: ClassDefStatement.styleText
                }
            },
            superTypes: []
        },
        Commit: {
            name: Commit.$type,
            properties: {
                id: {
                    name: Commit.id
                },
                message: {
                    name: Commit.message
                },
                tags: {
                    name: Commit.tags,
                    defaultValue: []
                },
                type: {
                    name: Commit.type
                }
            },
            superTypes: [Statement.$type]
        },
        Component: {
            name: Component.$type,
            properties: {
                decorator: {
                    name: Component.decorator
                },
                evolution: {
                    name: Component.evolution
                },
                inertia: {
                    name: Component.inertia,
                    defaultValue: false
                },
                label: {
                    name: Component.label
                },
                name: {
                    name: Component.name
                },
                visibility: {
                    name: Component.visibility
                }
            },
            superTypes: []
        },
        Curve: {
            name: Curve.$type,
            properties: {
                entries: {
                    name: Curve.entries,
                    defaultValue: []
                },
                label: {
                    name: Curve.label
                },
                name: {
                    name: Curve.name
                }
            },
            superTypes: []
        },
        Deaccelerator: {
            name: Deaccelerator.$type,
            properties: {
                name: {
                    name: Deaccelerator.name
                },
                x: {
                    name: Deaccelerator.x
                },
                y: {
                    name: Deaccelerator.y
                }
            },
            superTypes: []
        },
        Decorator: {
            name: Decorator.$type,
            properties: {
                strategy: {
                    name: Decorator.strategy
                }
            },
            superTypes: []
        },
        Direction: {
            name: Direction.$type,
            properties: {
                accDescr: {
                    name: Direction.accDescr
                },
                accTitle: {
                    name: Direction.accTitle
                },
                dir: {
                    name: Direction.dir
                },
                statements: {
                    name: Direction.statements,
                    defaultValue: []
                },
                title: {
                    name: Direction.title
                }
            },
            superTypes: [GitGraph.$type]
        },
        Edge: {
            name: Edge.$type,
            properties: {
                lhsDir: {
                    name: Edge.lhsDir
                },
                lhsGroup: {
                    name: Edge.lhsGroup,
                    defaultValue: false
                },
                lhsId: {
                    name: Edge.lhsId
                },
                lhsInto: {
                    name: Edge.lhsInto,
                    defaultValue: false
                },
                rhsDir: {
                    name: Edge.rhsDir
                },
                rhsGroup: {
                    name: Edge.rhsGroup,
                    defaultValue: false
                },
                rhsId: {
                    name: Edge.rhsId
                },
                rhsInto: {
                    name: Edge.rhsInto,
                    defaultValue: false
                },
                title: {
                    name: Edge.title
                }
            },
            superTypes: []
        },
        Entry: {
            name: Entry.$type,
            properties: {
                axis: {
                    name: Entry.axis,
                    referenceType: Axis.$type
                },
                value: {
                    name: Entry.value
                }
            },
            superTypes: []
        },
        Evolution: {
            name: Evolution.$type,
            properties: {
                stages: {
                    name: Evolution.stages,
                    defaultValue: []
                }
            },
            superTypes: []
        },
        EvolutionStage: {
            name: EvolutionStage.$type,
            properties: {
                boundary: {
                    name: EvolutionStage.boundary
                },
                name: {
                    name: EvolutionStage.name
                },
                secondName: {
                    name: EvolutionStage.secondName
                }
            },
            superTypes: []
        },
        Evolve: {
            name: Evolve.$type,
            properties: {
                component: {
                    name: Evolve.component
                },
                target: {
                    name: Evolve.target
                }
            },
            superTypes: []
        },
        GitGraph: {
            name: GitGraph.$type,
            properties: {
                accDescr: {
                    name: GitGraph.accDescr
                },
                accTitle: {
                    name: GitGraph.accTitle
                },
                statements: {
                    name: GitGraph.statements,
                    defaultValue: []
                },
                title: {
                    name: GitGraph.title
                }
            },
            superTypes: []
        },
        Group: {
            name: Group.$type,
            properties: {
                icon: {
                    name: Group.icon
                },
                id: {
                    name: Group.id
                },
                in: {
                    name: Group.in
                },
                title: {
                    name: Group.title
                }
            },
            superTypes: []
        },
        Info: {
            name: Info.$type,
            properties: {
                accDescr: {
                    name: Info.accDescr
                },
                accTitle: {
                    name: Info.accTitle
                },
                title: {
                    name: Info.title
                }
            },
            superTypes: []
        },
        Item: {
            name: Item.$type,
            properties: {
                classSelector: {
                    name: Item.classSelector
                },
                name: {
                    name: Item.name
                }
            },
            superTypes: []
        },
        Junction: {
            name: Junction.$type,
            properties: {
                id: {
                    name: Junction.id
                },
                in: {
                    name: Junction.in
                }
            },
            superTypes: []
        },
        Label: {
            name: Label.$type,
            properties: {
                negX: {
                    name: Label.negX,
                    defaultValue: false
                },
                negY: {
                    name: Label.negY,
                    defaultValue: false
                },
                offsetX: {
                    name: Label.offsetX
                },
                offsetY: {
                    name: Label.offsetY
                }
            },
            superTypes: []
        },
        Leaf: {
            name: Leaf.$type,
            properties: {
                classSelector: {
                    name: Leaf.classSelector
                },
                name: {
                    name: Leaf.name
                },
                value: {
                    name: Leaf.value
                }
            },
            superTypes: [Item.$type]
        },
        Link: {
            name: Link.$type,
            properties: {
                arrow: {
                    name: Link.arrow
                },
                from: {
                    name: Link.from
                },
                fromPort: {
                    name: Link.fromPort
                },
                linkLabel: {
                    name: Link.linkLabel
                },
                to: {
                    name: Link.to
                },
                toPort: {
                    name: Link.toPort
                }
            },
            superTypes: []
        },
        Merge: {
            name: Merge.$type,
            properties: {
                branch: {
                    name: Merge.branch
                },
                id: {
                    name: Merge.id
                },
                tags: {
                    name: Merge.tags,
                    defaultValue: []
                },
                type: {
                    name: Merge.type
                }
            },
            superTypes: [Statement.$type]
        },
        Note: {
            name: Note.$type,
            properties: {
                evolution: {
                    name: Note.evolution
                },
                text: {
                    name: Note.text
                },
                visibility: {
                    name: Note.visibility
                }
            },
            superTypes: []
        },
        Option: {
            name: Option.$type,
            properties: {
                name: {
                    name: Option.name
                },
                value: {
                    name: Option.value,
                    defaultValue: false
                }
            },
            superTypes: []
        },
        Packet: {
            name: Packet.$type,
            properties: {
                accDescr: {
                    name: Packet.accDescr
                },
                accTitle: {
                    name: Packet.accTitle
                },
                blocks: {
                    name: Packet.blocks,
                    defaultValue: []
                },
                title: {
                    name: Packet.title
                }
            },
            superTypes: []
        },
        PacketBlock: {
            name: PacketBlock.$type,
            properties: {
                bits: {
                    name: PacketBlock.bits
                },
                end: {
                    name: PacketBlock.end
                },
                label: {
                    name: PacketBlock.label
                },
                start: {
                    name: PacketBlock.start
                }
            },
            superTypes: []
        },
        Pie: {
            name: Pie.$type,
            properties: {
                accDescr: {
                    name: Pie.accDescr
                },
                accTitle: {
                    name: Pie.accTitle
                },
                sections: {
                    name: Pie.sections,
                    defaultValue: []
                },
                showData: {
                    name: Pie.showData,
                    defaultValue: false
                },
                title: {
                    name: Pie.title
                }
            },
            superTypes: []
        },
        PieSection: {
            name: PieSection.$type,
            properties: {
                label: {
                    name: PieSection.label
                },
                value: {
                    name: PieSection.value
                }
            },
            superTypes: []
        },
        Pipeline: {
            name: Pipeline.$type,
            properties: {
                components: {
                    name: Pipeline.components,
                    defaultValue: []
                },
                parent: {
                    name: Pipeline.parent
                }
            },
            superTypes: []
        },
        PipelineComponent: {
            name: PipelineComponent.$type,
            properties: {
                evolution: {
                    name: PipelineComponent.evolution
                },
                label: {
                    name: PipelineComponent.label
                },
                name: {
                    name: PipelineComponent.name
                }
            },
            superTypes: []
        },
        Radar: {
            name: Radar.$type,
            properties: {
                accDescr: {
                    name: Radar.accDescr
                },
                accTitle: {
                    name: Radar.accTitle
                },
                axes: {
                    name: Radar.axes,
                    defaultValue: []
                },
                curves: {
                    name: Radar.curves,
                    defaultValue: []
                },
                options: {
                    name: Radar.options,
                    defaultValue: []
                },
                title: {
                    name: Radar.title
                }
            },
            superTypes: []
        },
        Section: {
            name: Section.$type,
            properties: {
                classSelector: {
                    name: Section.classSelector
                },
                name: {
                    name: Section.name
                }
            },
            superTypes: [Item.$type]
        },
        Service: {
            name: Service.$type,
            properties: {
                icon: {
                    name: Service.icon
                },
                iconText: {
                    name: Service.iconText
                },
                id: {
                    name: Service.id
                },
                in: {
                    name: Service.in
                },
                title: {
                    name: Service.title
                }
            },
            superTypes: []
        },
        Size: {
            name: Size.$type,
            properties: {
                height: {
                    name: Size.height
                },
                width: {
                    name: Size.width
                }
            },
            superTypes: []
        },
        Statement: {
            name: Statement.$type,
            properties: {
            },
            superTypes: []
        },
        TreeNode: {
            name: TreeNode.$type,
            properties: {
                indent: {
                    name: TreeNode.indent
                },
                name: {
                    name: TreeNode.name
                }
            },
            superTypes: []
        },
        TreeView: {
            name: TreeView.$type,
            properties: {
                accDescr: {
                    name: TreeView.accDescr
                },
                accTitle: {
                    name: TreeView.accTitle
                },
                nodes: {
                    name: TreeView.nodes,
                    defaultValue: []
                },
                title: {
                    name: TreeView.title
                }
            },
            superTypes: []
        },
        Treemap: {
            name: Treemap.$type,
            properties: {
                accDescr: {
                    name: Treemap.accDescr
                },
                accTitle: {
                    name: Treemap.accTitle
                },
                title: {
                    name: Treemap.title
                },
                TreemapRows: {
                    name: Treemap.TreemapRows,
                    defaultValue: []
                }
            },
            superTypes: []
        },
        TreemapRow: {
            name: TreemapRow.$type,
            properties: {
                indent: {
                    name: TreemapRow.indent
                },
                item: {
                    name: TreemapRow.item
                }
            },
            superTypes: []
        },
        Wardley: {
            name: Wardley.$type,
            properties: {
                accDescr: {
                    name: Wardley.accDescr
                },
                accelerators: {
                    name: Wardley.accelerators,
                    defaultValue: []
                },
                accTitle: {
                    name: Wardley.accTitle
                },
                anchors: {
                    name: Wardley.anchors,
                    defaultValue: []
                },
                annotation: {
                    name: Wardley.annotation,
                    defaultValue: []
                },
                annotations: {
                    name: Wardley.annotations,
                    defaultValue: []
                },
                components: {
                    name: Wardley.components,
                    defaultValue: []
                },
                deaccelerators: {
                    name: Wardley.deaccelerators,
                    defaultValue: []
                },
                evolution: {
                    name: Wardley.evolution
                },
                evolves: {
                    name: Wardley.evolves,
                    defaultValue: []
                },
                links: {
                    name: Wardley.links,
                    defaultValue: []
                },
                notes: {
                    name: Wardley.notes,
                    defaultValue: []
                },
                pipelines: {
                    name: Wardley.pipelines,
                    defaultValue: []
                },
                size: {
                    name: Wardley.size
                },
                title: {
                    name: Wardley.title
                }
            },
            superTypes: []
        }
    } as const satisfies langium.AstMetaData
}

export const reflection = new MermaidAstReflection();
